let user = localStorage.getItem("currentUser") ? JSON.parse(localStorage.getItem("currentUser")).user : "";
let token = localStorage.getItem("token") ? localStorage.getItem("token"): "";

export const initialState = {
    userDetails: "" || user,
    token: "" || token,
    loading: false,
    errorMessage: null
};

export const AuthReducer = (initialState, action) => {
    switch (action.type) {
        case "REQUEST_LOGIN":
            return {
                ...initialState,
                loading: true
            };
        case "LOGIN_SUCCESS":
            return {
                ...initialState,
                user: action.payload.user,
                token: action.payload.token,
                loading: false
            };
        case "LOGOUT":
            return {
                ...initialState,
                user: "",
                token: "",
            };

        case "LOGIN_ERROR":
            return {
                ...initialState,
                loading: false,
                errorMessage: action.error
            };
        case "REGISTER_SUCCESS":
            return {
                ...initialState,
                user: action.payload.user,
                token: action.payload.token,
                loading: false
            };
        case "REGISTER_ERROR":
            return {
                ...initialState,
                loading: false,
                errorMessage: action.error
            };
        case "ACTIVATE_ERROR":
            return {
                ...initialState,
                loading: false,
                errorMessage: action.error
            };
        case "ACTIVATE_SUCCESS":
            return {
                ...initialState,
                user: action.payload.user,
                token: action.payload.token,
                loading: false
            };
        case "REQUEST_ACTIVATE":
            return {
                ...initialState,
                loading: true
            };

        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
